import React from 'react';
import PropTypes from "prop-types";
import {connect} from 'react-redux';
import includes from 'lodash/includes';
import capitalize from 'lodash/capitalize';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import {FormattedMessage} from 'react-intl';
import DocumentTitle from 'react-document-title';
import setDisplayName from 'recompose/setDisplayName';
import * as ResourceApi from 'api/resources';
import {startDeleteAction} from 'pages/DeleteConfirmation/actions';
import {startCopyPrizeAction} from 'pages/PrizeCopy/actions';
import ItemExplorer from 'components/common/ItemExplorer';
import CreatePrizeButton from 'pages/PrizeCreator/CreatePrizeButton';
import SecretSonicSpinner from 'components/common/SecretSonicSpinner';
import {openWinnerDetailModal} from 'components/WinnerDetailModal/actions';
import CopyPrizeModalContainer from 'pages/PrizeCopy/CopyPrizeModalContainer';
import WinnerDetailModal from 'components/WinnerDetailModal/WinnerDetailModal';
import {openPrizeChallengesModal} from 'components/PrizeChallengesModal/actions';
import CreatePrizeModalContainer from 'pages/PrizeCreator/CreatePrizeModalContainer';
import {getUserResourceActions, getUserServiceActions} from 'pages/Profile/selectors';
import {updatePageNumberForResourceAction, refreshPageAction} from 'resources/actions';
import PrizeChallengesModal from 'components/PrizeChallengesModal/PrizeChallengesModal';
import {createResourcePageSelector, createResourcePageItemsSelector} from 'resources/selectors';
import {removeAllFiltersForResourceAction, toggleSortForResourceAction} from 'viewOptions/actions';
import {createResourceSortsSelector, createResourceSortOptionsSelector} from 'viewOptions/selectors';
import {
  EmptyFunc,
  SortDirection,
  ItemExplorerViewOptions,
  pageCount,
  prependRecentIfFirstPage
} from 'utils/DBUtils';

const getResourcePage = createResourcePageSelector(ResourceApi.Types.Prize);
const getPageItems = createResourcePageItemsSelector(ResourceApi.Types.Prize);
const getSorts = createResourceSortsSelector(ResourceApi.Types.Prize);
const getSortOptions = createResourceSortOptionsSelector(ResourceApi.Types.Prize);

const getPrizeResourceActions = getUserResourceActions(ResourceApi.Types.PublishedPrize);
const getPrizeServiceActions = getUserServiceActions(ResourceApi.Types.PublishedPrize);

const mapStateToProps = state => {
  const page = getResourcePage(state.resources);
  const {fetchingPrizes} = state.listPrizes;

  const userCanPublishPrizes = includes(getPrizeServiceActions(state), 'PUBLISH_PRIZE');
  const userCanDeletePrizes = includes(getPrizeResourceActions(state), 'DELETE');

  return {
    userCanPublishPrizes,
    userCanDeletePrizes,
    fetchingPrizes,
    prizes: prependRecentIfFirstPage(
      page.page,
      page.count,
      [],
      getPageItems(state.resources)
    ),
    pageSize: page.count,
    currentPage: page.page,
    totalPrizes: page.total,
    sortOptions: getSortOptions(state),
    getSortDirectionForField: (field) => getSorts(state)[field] || SortDirection.Unsorted,
    isWinnerDetailModalOpen: state.winnerDetail.isOpen,
    isPrizeChallengesModalOpen: state.prizeChallengesModal.isOpen
  };
};

const mapDispatchToProps = {
  onPageSelected: page => updatePageNumberForResourceAction(ResourceApi.Types.Prize, page),
  onNextClicked: currentPage => updatePageNumberForResourceAction(ResourceApi.Types.Prize, currentPage+1),
  onPreviousClicked: currentPage => updatePageNumberForResourceAction(ResourceApi.Types.Prize, currentPage-1),
  showCopyPrizeModal: startCopyPrizeAction,
  openWinnerDetailModal,
  openPrizeChallengesModal,
  showDeletePrizeConfirmation: prize => startDeleteAction(
    prize,
    prize.resourceId,
    [],
    {},
    [refreshPageAction(ResourceApi.Types.Prize)]
  ),
  selectSort: field => toggleSortForResourceAction(ResourceApi.Types.Prize, field)
};

const ListPrizesTable = compose(
  withProps(props => ({
    showView: ItemExplorerViewOptions.List,
    itemsOnly: true,
    filterBarProps: {
      hidden: true
    },
    pagingBarProps: {
      count: pageCount(props.totalPrizes, props.pageSize),
      total: props.totalPrizes,
      currentPage: props.currentPage,
      maxPages: 10,
      onPageSelected: props.onPageSelected,
      onNextClicked: props.onNextClicked,
      onPreviousClicked: props.onPreviousClicked
    },
    tableProps: {
      scrolling: true,
      items: props.prizes,
      onRowClicked: EmptyFunc,
      getSortDirectionForField: props.getSortDirectionForField,
      onSortClick: colDetails => {
        if (colDetails.fieldName) {
          props.selectSort(colDetails.fieldName);
        }
      },
      colDetails: props.prizeTableConfig.columns.map(col => col(props))
    }
  })),
  setDisplayName('ListPrizesTable')
)(ItemExplorer);

const ListPrizesPage = compose(
  connect(mapStateToProps, mapDispatchToProps),
  setDisplayName('ListPrizesPage')
)(props => (
  <DocumentTitle title={props.prizeTableConfig.documentTitle}>
    <div className={`list-prizes-page ${props.prizeTableConfig.topLevelClassName}`}>
      {props.fetchingPrizes ? (
        <SecretSonicSpinner messageKey={props.prizeTableConfig.spinnerMessage} />
      ) : <ListPrizesTable {...props} />}
      <CreatePrizeModalContainer />
      <CopyPrizeModalContainer />
      {props.isWinnerDetailModalOpen && <WinnerDetailModal />}
      {props.isPrizeChallengesModalOpen && <PrizeChallengesModal />}
    </div>
  </DocumentTitle>
));

export default ListPrizesPage;



// WEBPACK FOOTER //
// ./public/pages/ListPrizes/ListPrizesPage.jsx